/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

   // Featured with collection
  var $slider1 = $(".featured-collection-slider-main");

  $slider1.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    speed: 400,
    infinite: true, // Enable infinite looping
    swipeToSlide: true,
    dots:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  //  js review slider
  $(document).ready(function () {

   $('#tp-widget-reviews').slick({
      infinite: false,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: true,
      prevArrow: '<button class="slick-prev custom-arrows"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="arrow-slider-circle" cx="12" cy="12" r="11.5" fill="none" stroke="#8C8C8C"></circle><path class="arrow-slider-shape" fill="#8C8C8C" d="M10.5088835 12l3.3080582-3.02451041c.2440777-.22315674.2440777-.5849653 0-.80812204-.2440776-.22315673-.6398058-.22315673-.8838834 0L9.18305826 11.595939c-.24407768.2231567-.24407768.5849653 0 .808122l3.75000004 3.4285714c.2440776.2231568.6398058.2231568.8838834 0 .2440777-.2231567.2440777-.5849653 0-.808122L10.5088835 12z"></path></svg></button>',
      nextArrow: '<button class="slick-next custom-arrows"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="arrow-slider-circle" cx="12" cy="12" r="11.5" fill="none" stroke="#8C8C8C"></circle><path class="arrow-slider-shape" fill="#8C8C8C" d="M10.5088835 12l3.3080582-3.02451041c.2440777-.22315674.2440777-.5849653 0-.80812204-.2440776-.22315673-.6398058-.22315673-.8838834 0L9.18305826 11.595939c-.24407768.2231567-.24407768.5849653 0 .808122l3.75000004 3.4285714c.2440776.2231568.6398058.2231568.8838834 0 .2440777-.2231567.2440777-.5849653 0-.808122L10.5088835 12z"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1076,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 824,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 581,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
});

// product variant
  document.addEventListener("DOMContentLoaded", function () {
      $(document).on('click', '.product-variant-image', function () {
          // Remove 'active' class from all variant images
          $(this).closest('.product-card').find('.product-variant-image').removeClass('active');

          // Add 'active' class to the clicked image
          $(this).addClass('active');

          var variantImage = $(this).attr('variant-image');
          $(this).closest('.product-card').find('.product-image .primary-image').attr('src', variantImage);

          var variantPrice = $(this).attr('variant-price');
          var variantCompare_at_price = $(this).attr('variant-compare-price');
          $(this).closest('.product-card').find('.price .price-sale').text(variantPrice);
          $(this).closest('.product-card').find('.price .price-compare').text(variantCompare_at_price);
        });
           // Show arrows on slide hover
        $(document).on('mouseenter', '.slick-slide', function() {
            $('.slick-arrow').addClass('hover-arrow');
        });
        $(document).on('mouseleave', '.slick-slide', function() {
            $('.slick-arrow').removeClass('hover-arrow');
        });
        $(document).on('mouseenter', '.slick-arrow', function() {
            $('.slick-arrow').addClass('hover-arrow');
        });
      });



      // custom ATF js


      
document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('.product-info--upsell-products__checkbox');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', function() {
      this.classList.toggle('selected');
      
      const variantId = this.getAttribute('data-id');
      console.log('Selected Variant ID:', variantId);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const upsellButton = document.querySelector('.product-info--upsell-products__button');
  const upsellContainer = document.querySelector('.product-info--upsell-products');

  if (upsellButton && upsellContainer) {
    upsellButton.addEventListener('click', function() {
      upsellContainer.classList.toggle('open');
      
      const isOpen = upsellContainer.classList.contains('open');
      this.setAttribute('aria-expanded', isOpen);
    });
  }
});

/**
 * @param {number} cents 
 * @returns {string} 
 */
function formatCurrency(cents) {
  const currencyCode = window.Shopify?.currency?.active || 'USD';
  const amount = cents / 100.0;

  try {
    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: currencyCode,
    }).format(amount);
  } catch (e) {
    return `${currencyCode} ${amount.toFixed(2)}`;
  }
}


document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  const $container = $(event.target).closest('.product-info, .product-form__variants');
  

  const moneyFormat = window.theme?.moneyFormat || '${{amount}}';

  if (variant) {

    const $selectedInput = $(`.block-swatch__radio[variant_id="${variant.id}"]`);
    const customTitle = $selectedInput.attr('data-product-title');

    console.log(customTitle);
    console.log($selectedInput)

    if (customTitle) {
      $('.product-meta__title.heading.h3').text(customTitle);
    }

    const newPrice = formatCurrency(variant.price, moneyFormat);
    $('.price.price--highlight').html(`<span class="visually-hidden">Sale price</span>${newPrice}`);

    const $comparePrice = $('.price.price--compare');
    const $badgeList = $('.product-info__badge-list');
    const $savingsBadge = $('.igSavingsPercentage');

    if (variant.compare_at_price > variant.price) {
      const newComparePrice = formatCurrency(variant.compare_at_price, moneyFormat);
      const savingsPercent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);

      $comparePrice.html(`<span class="visually-hidden">Regular price</span>${newComparePrice}`).show();
      $savingsBadge.text(`Save ${savingsPercent}%`);
      $badgeList.show();
    } else {
      $comparePrice.hide();
      $badgeList.hide();
    }
  }
});


$(document).on('click', '.custom-product-form__payment-container #AddToCart', function (e) {
  const $button = $(this);
  const $form = $button.closest('form');
  let upsellItems = [];

  $('.product-info--upsell-products__checkbox.selected').each(function () {
    const variantId = $(this).data('id');
    if (variantId) {
      upsellItems.push({
        id: variantId,
        quantity: 1
      });
    }
  });

  e.preventDefault();
  e.stopImmediatePropagation();

  const mainVariantId = $form.find('input[name="id"]').val();
  let items = [{
    id: mainVariantId,
    quantity: 1
  }];

  if (upsellItems.length > 0) {
    items = items.concat(upsellItems);
  }

  $button.attr('aria-busy', 'true').prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: items
    },
    dataType: 'json',
    success: function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
    },
    error: function (err) {
      console.error('Add to cart failed', err);
    },
    complete: function () {
      $button.attr('aria-busy', 'false').prop('disabled', false);
    }
  });
});

$(document).ready(function() {
    $(document).on('click', '.trigger-variant-picker', function() {
        var productId = $(this).data('target');
        var $overlay = $('#overlay-' + productId);
        
        $overlay.addClass('active');
        $overlay.find('.upsell-options').addClass('active');
    });

    function closeUpsell() {
        $('.upsell-options-overlay, .upsell-options').removeClass('active');
    }

    $(document).on('click', '.close-upsell-options', function() {
        closeUpsell();
    });

    $(document).on('click', '.upsell-options-overlay', function(e) {
        if ($(e.target).hasClass('upsell-options-overlay')) {
            closeUpsell();
        }
    });

    $(document).on('change', '.upsell-variant-select', function() {
        var $wrapper = $(this).closest('.upsell-options');
        var $selected = $(this).find('option:selected');
        
        var newPrice = $selected.data('price');
        var newTitle = $selected.data('title');
        var variantId = $selected.val();

        $wrapper.find('.price').text(newPrice);
        $wrapper.find('.upsell-options-variant').text(newTitle);
        
        $wrapper.find('input[name="id"]').val(variantId);
    });

    $(document).on('submit', '.upsell-variant-form, .upsell-direct-form', function(e) {
        e.preventDefault();
        var $form = $(this);
        var $btn = $form.find('button');
        
        $btn.addClass('loading').prop('disabled', true);
        $btn.attr("aria-busy", true);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $form.serialize(),
            dataType: 'json',
            success: function(response) {
                $btn.removeClass('loading').prop('disabled', false);
                $btn.attr("aria-busy", false);
                $('.upsell-options-overlay, .upsell-options').removeClass('active');
                
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
            },
            error: function(error) {
                $btn.removeClass('loading').prop('disabled', false);
                alert('Error adding to cart. Please try again.');
            }
        });
    });
});
$(document).ready(function() {
  $(document).on('change', '#shipping-protection', function(e) {
    const $input = $(this);
    const $wrapper = $input.closest('.shipping-protection-toggle-switch');
    const variantId = $input.data('variant-id');
    const isChecked = $input.is(':checked');

    $wrapper.css('pointer-events', 'none').css('opacity', '0.5');

    if (isChecked) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: variantId },
        dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        error: function() {
          $input.prop('checked', false);
          $wrapper.css('pointer-events', 'auto').css('opacity', '1');
          alert('Could not update cart.');
        }
      });
    } else {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { quantity: 0, id: variantId },
        dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        error: function() {
          $input.prop('checked', true);
          $wrapper.css('pointer-events', 'auto').css('opacity', '1');
        }
      });
    }
  });
});

$(document).ready(function() {
    function autoRemoveItems() {
        const $targetItems = $('.line-item.remove:not(.is-removing)');

        if ($targetItems.length === 0) return;

        $targetItems.each(function() {
            const $item = $(this);
            const $btn = $item.find('.line-item__remove-button');
            
            if ($btn.length > 0) {
                $item.addClass('is-removing');
                
                console.log('Target found: Removing item and locking UI...');
                
                $btn[0].click(); 
            }
        });
    }

    let debounceTimer;
    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(autoRemoveItems, 50); 
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});